import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { mt } from "../../../../St/comps/cStyle";
import { reFormatDate, reFormatDateString } from "../../../../utils/utils";
import TotalsActivity from "./TotalAct";
import { colors} from "@material-ui/core";
import { useTranslation } from "react-i18next";



function BodyActivity({ data, isLast ,infoData}) {
    const { t } = useTranslation(["forms", "translation"]);
  const cellS = {

    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.55rem",
    width: "150px",
    fontFamily: "Amiri-Regular",
    fontWeight:"bold",
  };

  var columns = [
    { title: "المخزن", field: "safe" },
    { title: "نوع العملية", field: "optype" },
    {title: "التاريخ", field: "date",},

    // { title: "التاريخ", field: "ddate",
    //     render: (expense) => reFormatDateString(expense.date)
    //  },
    { title: "رقم الفاتورة", field: "bill_no" },
    { title: "الصنف", field: "item_name" },
    { title: "الكمية", field: "qty" },
    { title: "السعر", field: "price" },
    { title: "الضريبه", field: "tax" },
    { title: "الاجمالي", field: "total" },
  ];
  const columns2 = [
    {title: "نوع الحركة", field: "Name_Trans",},
    {title: "المخزن", field: "Name_Safe",},
    {title: "رقم الفاتورة", field: "id",},
    {title: "التاريخ", field: "date",},
    // {title: "التاريخ", field: "ddate",
    //     render: (expense) => reFormatDateString(expense.date)
    // },
    {title: "الكمية", field: "val",},
    {title: "السعر", field: "exchange_price",},
    {title: "الإجمالي", field: "total",},
    // {label: "البيان", key: "Name_Customer",},
    // {label: "الفرع", key: "Name_Branche",},
  ];

  const newData = data.map((row, i) => {
    return {
      ...row,
      price: parseFloat(row.price).toFixed(2),
      tax: parseFloat(row.tax).toFixed(2),
      total: parseFloat( row.total).toFixed(2),
      date :reFormatDate(row?.ddate),
    };
  });
  return (
    <Grid item container style={{fontFamily: "Amiri-Regular"}}>
      <Grid item container style={{ direction: "rtl",paddingTop:"0.7rem"}}>
        <Grid
          item
          xs={12}
         
        >
          <MaterialTable
            style={{ boxShadow: "none" ,width:"100%"}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom:"2px",
                border: "solid 0px",
                border: "solid 0.1px",
               
                
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
            
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={infoData.kind ===2?columns2:columns}
            data={newData}
          />
          {isLast && infoData.kind !=2 && <TotalsActivity infoData={infoData} />}
        </Grid>
      </Grid>
   
      
    </Grid>
  );
}

export default BodyActivity;
